import { MainV3ApiBase } from './base';
import { UserFileShowView, UserFileToken } from '../types/uploadedFiles';

export const UserFilesApi = {
    // eslint-disable-next-line no-unused-vars
    create(contentBlob: Blob, onUploadProgress: (event: ProgressEvent) => any): Promise<UserFileShowView> {
        const data = new FormData();
        data.append('content', contentBlob);
        return MainV3ApiBase.appendPath('uploaded/user_files').postWithAxios(data, onUploadProgress);
    },
    show(token: UserFileToken): Promise<UserFileShowView> {
        return MainV3ApiBase.appendPath('uploaded/user_files')
            .withId(token)
            .get();
    },
};
